// GENERATED FILE — DO NOT EDIT.
// Source: hsos-shared/src/analytics/ — edit there, then run:
//   node scripts/sync-shared-modules.mjs
// Target: hsos-web vendored @hsos/shared

export * from "./events.js";
export * from "./groups.js";
export * from "./properties.js";
export * from "./flags.js";

/**
 * Analytics environment.
 *
 * Every event is stamped with this so a preview deploy or a developer's laptop
 * cannot contaminate production funnels. Insights and dashboards filter on
 * `environment = production`; nothing is dropped at ingest, because a preview
 * event you cannot see is indistinguishable from instrumentation that does not
 * work.
 */
export type AnalyticsEnvironment = "production" | "preview" | "development";

export function resolveAnalyticsEnvironment(
  raw: string | undefined,
): AnalyticsEnvironment {
  const normalized = raw?.trim().toLowerCase();
  if (normalized === "production" || normalized === "prod") return "production";
  if (normalized === "preview" || normalized === "staging") return "preview";
  return "development";
}
